import { render, staticRenderFns } from "./argentina.vue?vue&type=template&id=62d7a02c&"
import script from "./argentina.vue?vue&type=script&lang=js&"
export * from "./argentina.vue?vue&type=script&lang=js&"
import style0 from "./argentina.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryTop: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryTop.vue').default,CountryDescription: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryDescription.vue').default,CountryFeaturesWhite: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryFeaturesWhite.vue').default,CountryChartCircle: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryChartCircle.vue').default,CountryArgentinaPaymentCard: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryArgentinaPaymentCard.vue').default,FooterTop: require('/builds/pagsmile/front-end/pagsmile-web/components/footer/footerTop.vue').default})
